import { gql } from '@apollo/client';

export const UpdateClassFirstLevel = gql`
mutation UpdateClassFirstLevel($updateClassFirstLevelId: ID!, $content: contentUpdateClassFirstLevel!) {
  updateClassFirstLevel(id: $updateClassFirstLevelId, content: $content) {
    status
  }
}
`